import React from 'react';
import Slider from 'react-slick';

import { importAllImagesFromFolder } from 'lib/utils/imagesUtils';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './Carousel.module.scss';
import './Carousel.scss';

const Carousel = ({ context }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: window.innerWidth > 540 ? 3 : 1,
    slidesToScroll: 1,
    autoplay: true,
    lazyLoad: 'ondemand'
  };

  const images = importAllImagesFromFolder(context);

  return ( 
    <div className={ styles.Carousel }>
      <Slider {...settings}>
        { images && images.map(path => 
          <img src={ path } key={ path }
            width="320"
          />) }
      </Slider>
    </div>
  );
};
 
export default Carousel;